import React from "react";

const academicData = [
  {
    id: 1,
    institution: "University of South Africa (UNISA)",
    institutionUrl: "https://www.unisa.ac.za/",
    institutionBadge: "images/unisa.png",
    degree: "Master of Science in Computer Science",
    period: "2026 - Present",
    description: 'Full dissertation research on Machine Learning, Space Exploration and Mission: Automated Classification of Astronomical Objects.',
    descriptionInBold: 'In Progress - '
  },
  {
    id: 2,
    institution: "University of South Africa (UNISA)",
    institutionUrl: "https://www.unisa.ac.za/",
    institutionBadge: "images/unisa.png",
    degree: "Bachelor of Science Honours in Computer Science",
    period: "2024 - 2026",
    description: 'Machine Learning, Deep Learning, Software Engineering, Ontology Engineering, Logic-Based Reasoning, Computer Vision, Natural Language Processing.',
    descriptionInBold: null
  },
  {
    id: 3,
    institution: "Institut Supérieur de Statistique de Lubumbashi",
    institutionUrl: "https://iss-lubumbashi.org/",
    institutionBadge: "images/iss.png",
    degree: "Bachelor of Science in Computer Science",
    period: "2010 - 2013",
    description: 'Computer Science, Mathematical Sciences, Life Sciences, and Physical Sciences',
    descriptionInBold: 'Organised fields:'
  }
]

const Academic = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-gradient-to-br from-slate-900 via-purple-900/20 to-slate-900 relative">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-cyan-400 via-purple-400 to-emerald-400 bg-clip-text text-transparent mb-4">
            Academic Background
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            A journey through my studies, research, and academic achievements
          </p>
        </div>

        {/* Professional Grid Layout */}
        <div className="grid grid-cols-1 gap-8 max-w-7xl mx-auto">
           <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-lg border border-gray-700/50 rounded-2xl shadow-xl p-6 h-full transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:border-cyan-500/50">
          {academicData.map((academic, index) => (
            <div key={academic.id} className="group relative">
             
                {/* Status Badge */}
                <div className="absolute -top-3 -right-3">
                  <div className="w-6 h-6 bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 rounded-full border-2 border-slate-900 flex items-center justify-center">
                    <span className="text-xs font-bold text-slate-900">
                      {index + 1}
                    </span>
                  </div>
                </div>

                {/* Company Badge/Icon */}
                <div className="flex items-stretch mb-8">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-purple-500/20 border border-cyan-500/30 flex items-center justify-center mr-4 shrink-0 group-hover:border-cyan-400/50 transition-colors">
                    {academic.institutionBadge ? (
                      <img
                        src={academic.institutionBadge}
                        alt={`${academic.institution} certificate`}
                        className="w-full h-full object-cover rounded-xl"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                    ) : null}
                    <svg
                      className={academic.institutionBadge ? "hidden" : "w-7 h-7 text-cyan-400"}
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  </div>
                  <div className="flex-1 h-14 text-left flex flex-col justify-between">
                    <h3 className="text-2xl font-bold text-white leading-tight">
                      {academic.degree}
                    </h3>
                    <p className="text-lg text-emerald-400 font-semibold leading-tight">
                      {academic.institution}
                    </p>

                                       <span className="">
                                          <a
                      href={academic.institutionUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs font-medium text-cyan-300 hover:text-cyan-200 transition-colors leading-tight"
                    >
                      {`VISIT WEBSITE`}
                    </a>
                    </span>
                  </div>
                </div>

                {/* Experience Details */}
                <div className="relative pl-20 mb-8 text-left">
                  <div className="absolute left-8 top-1 bottom-1 w-px bg-gradient-to-b from-cyan-400 via-slate-400 to-emerald-400" />
                  <div className="absolute left-8 top-2 w-3 h-3 -translate-x-[5px] rounded-full border-2 border-cyan-300 bg-slate-950 shadow-[0_0_0_4px_rgba(34,211,238,0.12)]" />
                  <div className="space-y-8">
                 

                  
                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <p className="text-gray-300 text-base font-semibold leading-relaxed">
                              {academic.descriptionInBold ? <span className="font-bold">{academic.descriptionInBold}</span> : ''} {academic.description}
                            </p>
                          </div>
                        </div>
                
                 
                  </div>
                </div>


                <div className="flex items-center justify-between flex-wrap gap-2 mt-auto mb-12">
                  <span className="inline-block px-3 py-1 text-xs font-semibold text-cyan-300 bg-cyan-900/30 rounded-full border border-cyan-500/30">
                    {academic.period}
                  </span>
                </div>
              </div>
          
          ))}
            </div>
        </div>
      </div>
    </div>
  );
};

export default Academic;
